import SessionReport from './component';

import _routes from './routes';

export const routes = _routes;

export default SessionReport;



// WEBPACK FOOTER //
// ./containers/Group/SessionReport/index.js